// Shared "eyebrow + heading (+ description)" block used to open page sections
// consistently instead of every page hand-rolling its own heading markup.
const SectionHeader = ({ eyebrow, title, description, align = "left", className = "" }) => {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";

  return (
    <div className={`mb-12 md:mb-14 ${alignment} ${className}`}>
      {eyebrow && (
        <p className="text-primary font-montserrat font-bold tracking-wide text-sm mb-3">
          {eyebrow.toUpperCase()}
        </p>
      )}
      <h2 className="text-3xl md:text-4xl font-bold text-foreground">{title}</h2>
      {description && (
        <p className={`text-muted-foreground text-lg mt-4 ${align === "center" ? "max-w-2xl mx-auto" : "max-w-2xl"}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
